/*
 * iurop-stores — "Dónde estamos" / Locales — Kawaicafe
 * 1) Slider "Nuestros locales": scroll-snap + flechas prev/next que desplazan
 *    el track un slide (patrón de iurop-locations.js). Detecta el eje según el
 *    breakpoint (vertical en escritorio, horizontal deslizable en móvil) y
 *    oculta con .is-hidden la flecha del extremo (arriba al inicio, abajo al final).
 * 2) Scroll-reveal: IntersectionObserver que añade .is-inview a los [data-sr]
 *    (el CSS solo los oculta si hay JS: clase .kawaii-stores--sr) y respeta
 *    prefers-reduced-motion desde el propio CSS. Sin dependencias.
 */
(function () {
  function initSlider(wrap) {
    if (!wrap || wrap.dataset.ksInit) return;
    wrap.dataset.ksInit = '1';
    var track = wrap.querySelector('[data-ks-track]');
    var prev = wrap.querySelector('[data-ks-prev]');
    var next = wrap.querySelector('[data-ks-next]');
    if (!track) return;

    // Eje del slider: horizontal si el contenido desborda a lo ancho (móvil),
    // vertical en caso contrario (columna de pastillas de escritorio).
    function horizontal() {
      return track.scrollWidth > track.clientWidth + 4;
    }

    function step() {
      var slide = track.querySelector('.kawaii-stores__pill-slide');
      var cs = getComputedStyle(track);
      if (!slide) return Math.round(track.clientHeight * 0.8);
      if (horizontal()) {
        return slide.offsetWidth + (parseFloat(cs.columnGap || cs.gap) || 0);
      }
      return slide.offsetHeight + (parseFloat(cs.rowGap || cs.gap) || 0);
    }

    // "Ver mas" avanza una PAGINA (lo que cabe menos una tarjeta de solape, para
    // no perder el hilo), no una tarjeta: con 6 locales pasa de 5 clics a 2.
    function pageStep() {
      var one = step();
      var visible = horizontal() ? track.clientWidth : track.clientHeight;
      return Math.max(one, visible - one);
    }

    // Cuantos locales quedan por ver hacia abajo (para el contador del boton).
    function restantes() {
      var slides = track.querySelectorAll('.kawaii-stores__pill-slide');
      var n = 0;
      var lim = horizontal()
        ? track.scrollLeft + track.clientWidth + 2
        : track.scrollTop + track.clientHeight + 2;
      for (var i = 0; i < slides.length; i++) {
        var el = slides[i];
        var fin = horizontal() ? el.offsetLeft + el.offsetWidth : el.offsetTop + el.offsetHeight;
        if (fin > lim) n++;
      }
      return n;
    }

    // "Ver mas": boton de texto bajo la columna (solo escritorio, el CSS lo
    // oculta en movil). Avanza una pagina; en el final pasa a "Ver menos" y
    // vuelve arriba. Si la lista NO desborda, no se muestra.
    var more = wrap.querySelector('[data-ks-more]');
    var moreLabel = wrap.querySelector('[data-ks-more-label]');
    var moreCount = wrap.querySelector('[data-ks-more-count]');
    var moreTxt = moreLabel ? moreLabel.textContent : '';
    var lessTxt = more ? (more.getAttribute('data-less') || 'Ver menos') : '';
    var trackId = track.id || (track.id = 'ks-track-' + Math.round(track.offsetTop) + '-' + track.children.length);

    function update() {
      var h = horizontal();
      var pos = h ? track.scrollLeft : track.scrollTop;
      var max = h
        ? track.scrollWidth - track.clientWidth
        : track.scrollHeight - track.clientHeight;
      if (prev) prev.classList.toggle('is-hidden', pos <= 2);
      if (next) next.classList.toggle('is-hidden', pos >= max - 2);
      if (more) {
        var atEnd = pos >= max - 2;
        more.classList.toggle('is-hidden', max <= 4);
        more.classList.toggle('is-end', atEnd);
        if (moreLabel) moreLabel.textContent = atEnd ? lessTxt : moreTxt;
        // Contador: dice cuantos faltan, asi el boton no es una caja negra.
        if (moreCount) moreCount.textContent = atEnd ? '' : ' (+' + restantes() + ')';
        more.setAttribute('aria-expanded', atEnd ? 'true' : 'false');
        more.setAttribute('aria-controls', trackId);
      }
    }

    function go(dir) {
      var d = dir * step();
      // En pestana oculta la animacion de scroll no corre: salto directo (asi
      // tambien se puede verificar por codigo).
      var b = document.hidden ? 'auto' : 'smooth';
      if (horizontal()) track.scrollBy({ left: d, behavior: b });
      else track.scrollBy({ top: d, behavior: b });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    if (more) more.addEventListener('click', function () {
      var b = document.hidden ? 'auto' : 'smooth';
      if (more.classList.contains('is-end')) {
        var o = { behavior: b };
        if (horizontal()) { o.left = 0; } else { o.top = 0; }
        track.scrollTo(o);
      } else if (horizontal()) {
        track.scrollBy({ left: pageStep(), behavior: b });
      } else {
        track.scrollBy({ top: pageStep(), behavior: b });
      }
      // El scroll suave termina despues del clic: el `scroll` ya refresca el
      // estado, esto solo cierra el caso del salto instantaneo.
      window.setTimeout(update, 60);
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initReveal(root) {
    if (root.dataset.ksSr) return;
    root.dataset.ksSr = '1';
    // Solo se ocultan los [data-sr] cuando el JS está listo (clase en el CSS).
    root.classList.add('kawaii-stores--sr');
    var pending = Array.prototype.slice.call(root.querySelectorAll('[data-sr]'));

    function revealEl(el) {
      el.classList.add('is-inview');
      var i = pending.indexOf(el);
      if (i >= 0) pending.splice(i, 1);
    }

    // BARRIDO por rects: revela lo que esté en pantalla. Es el mecanismo FIABLE
    // (IntersectionObserver no siempre dispara con ancestros overflow:clip);
    // IO queda como vía rápida cuando sí funciona.
    function sweep() {
      if (!pending.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      pending.slice().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh - 40 && r.bottom > 0) revealEl(el);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              revealEl(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      pending.forEach(function (el) { io.observe(el); });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; sweep(); });
    }, { passive: true });
    window.addEventListener('resize', sweep);
    sweep(); // primer barrido: lo visible al cargar se muestra ya
  }

  // 3) Mapa interactivo (comunidad <-> pastilla, bidireccional). Máquina de
  //    estados con DOS capas: `hovered` (temporal, al pasar el ratón/foco) y
  //    `selected` (persistente, al pulsar/tocar). Así funciona igual en móvil
  //    (donde no hay hover): un toque en la comunidad la SELECCIONA, la ilumina,
  //    resalta su(s) pastilla(s) y las trae a la vista; otro toque la suelta.
  //    Solo una comunidad activa a la vez (exclusividad). Respeta reduced-motion.
  function initMap(root) {
    if (root.dataset.ksMap) return;
    root.dataset.ksMap = '1';

    var regions = root.querySelectorAll('.kawaii-stores__region--local[data-region]');
    if (!regions.length) return;

    var reduce = false;
    try {
      reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    // Lista única de comunidades presentes (madrid/murcia/asturias).
    var names = [];
    Array.prototype.forEach.call(regions, function (el) {
      var r = el.getAttribute('data-region');
      if (r && names.indexOf(r) < 0) names.push(r);
    });

    function pillSlidesFor(region) {
      return root.querySelectorAll('.kawaii-stores__pill-slide[data-region="' + region + '"]');
    }
    function regionEls(region) {
      return root.querySelectorAll('.kawaii-stores__region--local[data-region="' + region + '"]');
    }

    // Pinta/despinta una comunidad y TODAS sus pastillas a la vez.
    function paint(region, on) {
      Array.prototype.forEach.call(regionEls(region), function (el) {
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      Array.prototype.forEach.call(pillSlidesFor(region), function (li) {
        var pill = li.querySelector('.kawaii-stores__pill');
        if (pill) pill.classList.toggle('is-highlight', on);
      });
    }

    var selected = null; // clic/tap (persistente)
    var hovered = null;  // ratón/foco (temporal)

    // Lo iluminado = hover si lo hay, si no la selección. Repinta las 3 (exclusivo).
    function apply() {
      var show = hovered || selected;
      names.forEach(function (r) { paint(r, r === show); });
    }
    function setHover(r) { hovered = r; apply(); }
    function clearHover(r) { if (hovered === r) hovered = null; apply(); }

    // Trae a la vista TODAS las tiendas de la comunidad, no solo la primera:
    // Asturias tiene tres y con `scrollIntoView` sobre la primera las otras dos
    // se quedaban fuera del carrusel, asi que parecia que solo se resaltaba una
    // (QA: "solo se resalta la primera de la lista").
    function scrollToPill(region) {
      var slides = pillSlidesFor(region);
      if (!slides.length) return;
      if (!reduce) {
        Array.prototype.forEach.call(slides, function (li) {
          var pill = li.querySelector('.kawaii-stores__pill');
          if (!pill) return;
          pill.classList.remove('is-pop');
          void pill.offsetWidth; // reinicia la animación
          pill.classList.add('is-pop');
        });
      }
      var track = root.querySelector('[data-ks-track]');
      var first = slides[0];
      var last = slides[slides.length - 1];
      // En MOVIL las pastillas se apilan y el track NO scrollea (las 6 caben),
      // asi que al pulsar una comunidad no se movia nada y parecia que el mapa
      // no reaccionaba (QA locales). Sin scroller propio, se lleva la PAGINA al
      // grupo, que ademas ya viene resaltado y con el "pop".
      var propio = track && (track.scrollWidth - track.clientWidth > 4 || track.scrollHeight - track.clientHeight > 4);
      if (!propio) {
        try { first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (e) { first.scrollIntoView(); }
        return;
      }
      var horiz = track.scrollWidth - track.clientWidth > 4;
      var ini = horiz ? first.offsetLeft : first.offsetTop;
      var fin = horiz ? (last.offsetLeft + last.offsetWidth) : (last.offsetTop + last.offsetHeight);
      var visible = horiz ? track.clientWidth : track.clientHeight;
      var max = horiz ? (track.scrollWidth - track.clientWidth) : (track.scrollHeight - track.clientHeight);
      var destino = ini - Math.max(0, (visible - (fin - ini)) / 2);
      destino = Math.max(0, Math.min(destino, max));
      var opts = { behavior: reduce ? 'auto' : 'smooth' };
      opts[horiz ? 'left' : 'top'] = destino;
      try { track.scrollTo(opts); } catch (e) { if (horiz) track.scrollLeft = destino; else track.scrollTop = destino; }
    }

    function toggleSelect(region) {
      selected = (selected === region) ? null : region;
      hovered = null;
      apply();
      if (selected) scrollToPill(selected);
    }

    // Pastilla -> comunidad: al pasar el ratón/foco sobre la tarjeta se ilumina
    // su comunidad en el mapa (y al revés, gracias a paint()).
    Array.prototype.forEach.call(
      root.querySelectorAll('.kawaii-stores__pill-slide[data-region]'),
      function (li) {
        var region = li.getAttribute('data-region');
        li.addEventListener('mouseenter', function () { setHover(region); });
        li.addEventListener('mouseleave', function () { clearHover(region); });
        li.addEventListener('focusin', function () { setHover(region); });
        li.addEventListener('focusout', function () { clearHover(region); });
      }
    );

    // Comunidad -> pastilla(s): hover ilumina; clic/tap/Enter SELECCIONA + scroll.
    Array.prototype.forEach.call(regions, function (el) {
      var region = el.getAttribute('data-region');
      el.addEventListener('mouseenter', function () { setHover(region); });
      el.addEventListener('mouseleave', function () { clearHover(region); });
      el.addEventListener('focus', function () { setHover(region); });
      el.addEventListener('blur', function () { clearHover(region); });
      el.addEventListener('click', function () { toggleSelect(region); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggleSelect(region);
        }
      });
    });
  }

  function initSection(root) {
    initReveal(root);
    initSlider(root.querySelector('[data-ks-slider]'));
    initMap(root);
  }

  function boot() {
    document.querySelectorAll('.kawaii-stores').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.kawaii-stores');
    if (root) initSection(root);
  });
})();
